import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../../api/apihandler';
import { BLOCKED_USER_LIST, BLOCK_UNBLOCK_FOLLOWER } from '../../../api/constants';
import { apiSucceeded, getAvatarColor, getInitials } from '../feed/feedUtils';
import MyStatsWidget from '../../../components/nemonto/MyStatsWidget';
import PromoCard from '../../../components/nemonto/PromoCard';
import EmptyState from '../../../components/nemonto/EmptyState';
import './social-list-page.css';

const PersonAvatar = ({ photo, name }) => {
  if (photo) return <img src={photo} alt={name} className="nmsl-avatar" />;
  return (
    <div className="nmsl-avatar" style={{ background: getAvatarColor(name || 'User') }}>
      {getInitials(...(name || 'User').split(' '))}
    </div>
  );
};

const BlockAccountsPage = () => {
  const [blocked, setBlocked] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyIds, setBusyIds] = useState(new Set());

  async function loadBlocked() {
    setLoading(true);
    try {
      const res = await apiHandler(BLOCKED_USER_LIST, 'POST', { page: 1, limit: 100 });
      if (apiSucceeded(res)) setBlocked(res?.data?.data?.users?.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }

  useEffect(() => { loadBlocked(); }, []);

  async function unblock(userId) {
    if (busyIds.has(userId)) return;
    setBusyIds((prev) => new Set([...prev, userId]));
    try {
      const res = await apiHandler(BLOCK_UNBLOCK_FOLLOWER, 'POST', { follower_id: userId });
      if (apiSucceeded(res)) {
        setBlocked((prev) => prev.filter((b) => b?.follower?.id !== userId));
      }
    } catch (e) { console.error(e); }
    finally {
      setBusyIds((prev) => { const next = new Set(prev); next.delete(userId); return next; });
    }
  }

  return (
    <div className="nmsl-layout">
      <div className="nmsl-main">
        <div className="nmsl-page-header">
          <div className="nmsl-header">
            <h3 className="nmsl-title">Blocked Accounts</h3>
            {blocked.length > 0 && <span className="nmsl-count-pill">{blocked.length}</span>}
          </div>
          <p className="nmsl-subtitle">Accounts you won't see or hear from.</p>
        </div>

        <div className="nmsl-main-body">
          {loading && <p className="nmsl-loading">Loading…</p>}
          {!loading && blocked.length === 0 && (
            <EmptyState icon="block" title="No blocked accounts" sub="Accounts you block will show up here." />
          )}

          {!loading && blocked.length > 0 && (
            <div className="nmsl-grid">
              {blocked.map((b) => {
                const user = b?.follower;
                const name = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User';
                return (
                  <div key={b.id} className="nmsl-card">
                    <PersonAvatar photo={user?.user_setting?.photo} name={name} />
                    <div className="nmsl-body">
                      <div className="nmsl-name">{name}</div>
                    </div>
                    <button
                      type="button"
                      className="nmsl-follow-btn"
                      disabled={busyIds.has(user?.id)}
                      onClick={() => unblock(user?.id)}
                    >
                      Unblock
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <aside className="nmsl-rail">
        <PromoCard
          label="Stay in control"
          title="Manage who can reach you"
          sub="Blocked accounts can't see your posts, comment, or message you."
          ctaText="Review followers"
          to="/followers"
        />
        <MyStatsWidget />
      </aside>
    </div>
  );
};

export default BlockAccountsPage;
